<template>
  <v-container
    class="elevation-2 mx-auto"
    style="border-radius:10px;min-width:160px;max-width: 270px;"
    :style="{ width: width }"
  >
    <v-row
      justify="center"
      align="center"
      class="mb-2"
      :class="`${color}`"
      style="border-radius:10px 10px 0px 0px"
    >
      <v-col class="d-flex justify-center align-center">
        <span class="white--text">
          {{ title }}
        </span>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mt-2">
      <v-col class="d-flex justify-center align-center">
        {{ TOOL.thousandComma(value) }}
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    value: {
      type: [Number, String],
      default: 0
    },
    color: {
      type: String,
      default: "secondary"
    },
    width: {
      type: [Number, String],
      default: "160px"
    }
  }
};
</script>
<style lang="scss"></style>
